import React from "react";
import Pagination from "react-js-pagination";
import cn from "classnames";

export const PaginationType = ({
  totalItems,
  currentPage,
  countPerPage = 20,
  onPageChange,
  addClass,
}) => {
  const handlePageChange = (pageNumber) =>
    pageNumber !== currentPage && onPageChange(pageNumber);

  return totalItems > countPerPage ? (
    <Pagination
      activePage={parseInt(currentPage)}
      totalItemsCount={totalItems}
      itemsCountPerPage={countPerPage}
      onChange={handlePageChange.bind(this)}
      innerClass={cn("pagination", {[addClass]: !!addClass})}
      itemClass="page-item"
      linkClass="page-link"
    />
  ) : null;
};
